import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Home from '@/views/Home.vue';
import Administration from '@/views/administration/Administration.vue';
import AdministrationHome from '@/views/administration/Home.vue';
import UserSearch from '@/views/administration/UserSearch.vue';
import UserProfileView from '@/views/administration/UserProfileView.vue';
import UserAdd from '@/views/administration/UserAdd.vue';
import UserEdit from '@/views/administration/UserEdit.vue';
import CenterList from '@/views/administration/CenterList.vue';
import CenterAdd from '@/views/administration/CenterAdd.vue';
import CenterEdit from '@/views/administration/CenterEdit.vue';
import CenterProfile from '@/views/administration/CenterProfile.vue';
import UserNotificationHome from '@/views/administration/UserNotifications/Home.vue';
import UserNotificationAdd from '@/views/administration/UserNotifications/NotificationAdd.vue';
import UserNotificationView from '@/views/administration/UserNotifications/NotificationView.vue';
import UserNotificationEdit from '@/views/administration/UserNotifications/NotificationEdit.vue';
import UserNotificationList from '@/views/administration/UserNotifications/NotificationList.vue';
import ReleaseNotesHome from '@/views/administration/ReleaseNotes/Home.vue';
import ReleaseNotesAdd from '@/views/administration/ReleaseNotes/NotificationAdd.vue';
import ReleaseNotesView from '@/views/administration/ReleaseNotes/NotificationView.vue';
import ReleaseNotesEdit from '@/views/administration/ReleaseNotes/NotificationEdit.vue';
import ReleaseNotesList from '@/views/administration/ReleaseNotes/NotificationList.vue';
import Documents from '@/views/documents/Documents.vue';
import DocumentSearch from '@/views/documents/DocumentSearch.vue';
import Certificates from '@/views/certificates/Certificates.vue';
import CertificatesHome from '@/views/certificates/Home.vue';
import CertificatesReprint from '@/views/certificates/CertificatesReprint.vue';
import Reports from '@/views/reports/Reports.vue';
import ReportsHome from '@/views/reports/Home.vue';
import ReportsStudentCertificationTracking from '@/views/reports/StudentCertificationTracking.vue';
import ReportInjuryReport from '@/views/reports/InjuryReport.vue';
import Students from '@/views/students/Students.vue';
import StudentsHome from '@/views/students/Home.vue';
import StudentsSearch from '@/views/students/Search.vue';
import StudentProfileView from '@/views/students/StudentProfileView.vue';
import StudentEditView from '@/views/students/StudentEditView.vue';
import Forms from '@/views/forms/Forms.vue';
import FormsHome from '@/views/forms/Home.vue';
import MaterialRequestAdd from '@/views/forms/Material/RequestAdd.vue';
import MaterialRequestEdit from '@/views/forms/Material/RequestEdit.vue';
import MaterialRequestView from '@/views/forms/Material/RequestView.vue';
import MaterialRequestMaintenanceHome from '@/views/administration/Material/Home.vue';
import MaterialRequestItemList from '@/views/administration/Material/ItemList.vue';
import MaterialRequestItemAdd from '@/views/administration/Material/ItemAdd.vue';
import MaterialRequestItemEdit from '@/views/administration/Material/ItemEdit.vue';
import CertificateRequestFormAdd from '@/views/forms/CertificateRequestFormAdd.vue';
import CertificateRequestFormView from '@/views/forms/CertificateRequestFormView.vue';
import InjuryReportAdd from '@/views/forms/InjuryReportAdd.vue';
import InjuryReportView from '@/views/forms/InjuryReportView.vue';
import InjuryReportEdit from '@/views/forms/InjuryReportEdit.vue';
import AllForms from '@/views/forms/FormRequests/AllForms.vue';
import ActionableForms from '@/views/forms/FormRequests/ActionableForms.vue';
import Profile from '@/views/profile/Profile.vue';
import ProfileHome from '@/views/profile/Home.vue';
import ContactHome from '@/views/contact/Home.vue';
import ReleaseNotes from '@/views/releasenotes/ReleaseNotes.vue';
import ReleaseNoteHome from '@/views/releasenotes/Home.vue';
import UserNotifications from '@/views/usernotifications/UserNotifications.vue';
import UserNotificationsHome from '@/views/usernotifications/Home.vue';
import Layout from '@/views/Layout.vue';
import {Instructor, Field, Office, Director} from './services/Authorize';
import {HomeRoute, LoginRoute, ResetPasswordRoute, ForgotPasswordRoute} from './services/Authorize';
import _ from 'underscore';
import {trackPage} from '@/services/analytics';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login',
            name: LoginRoute,
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
        },
        {
            path: '/resetpassword',
            name: ResetPasswordRoute,
            component: () => import('./views/ResetPassword.vue')
        },
        {
            path: '/forgotpassword',
            name: ForgotPasswordRoute,
            component: () => import('./views/ForgotPassword.vue')
        },
        {
            path: '/',
            name: HomeRoute,
            component: Layout,
            children: [
                {
                    path: 'administration',
                    component: Administration,
                    meta: {
                        permission: Office
                    },
                    children: [
                        { path: '', component: AdministrationHome},
                        { path: 'user/search', component: UserSearch},
                        { path: 'user/add', component: UserAdd},
                        { path: 'user/profile/:id', component: UserProfileView, props: true },
                        { path: 'user/edit/:id', component: UserEdit, props: true },
                        { path: 'center/list', component: CenterList},
                        { path: 'center/add', component: CenterAdd},
                        { path: 'center/profile/:id', component: CenterProfile, props: true },
                        { path: 'center/edit/:id', component: CenterEdit, props: true },
                        { path: 'materialrequestmaintenance', component: MaterialRequestMaintenanceHome},
                        { path: 'materialrequestmaintenance/item', component: MaterialRequestItemAdd,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('material/loadMaterialCategories', true);
                                next();
                            }
                        },
                        { path: 'materialrequestmaintenance/item/:id', component: MaterialRequestItemEdit, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('material/loadMaterialItems', true);
                                next();
                            }
                        },
                        { path: 'materialrequestmaintenance/items', component: MaterialRequestItemList,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('material/loadMaterialItems', true);
                                next();
                            }
                        },
                        { path: 'usernotifications', component: UserNotificationHome,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        },
                        { path: 'usernotifications/notification', component: UserNotificationAdd,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        },
                        { path: 'usernotifications/notification/:id', component: UserNotificationView, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        },
                        { path: 'usernotifications/notification/:id/edit', component: UserNotificationEdit, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        },
                        { path: 'usernotifications/notifications', component: UserNotificationList,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        },
                        { path: 'releasenotes', component: ReleaseNotesHome,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        },
                        { path: 'releasenotes/notification', component: ReleaseNotesAdd,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        },
                        { path: 'releasenotes/notification/:id', component: ReleaseNotesView, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        },
                        { path: 'releasenotes/notification/:id/edit', component: ReleaseNotesEdit, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        },
                        { path: 'releasenotes/notifications', component: ReleaseNotesList,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        }
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('loadCenters');
                        store.dispatch('loadUserProfiles');
                        store.dispatch('loadCertificateForms', true);
                        next();
                    }
                },
                {
                    path: 'documents',
                    component: Documents,
                    children: [
                        { path: '', component: DocumentSearch}
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('documents/loadDocuments', null, {root: true}).finally(next);
                    }
                },
                {
                    path: 'certificates',
                    component: Certificates,
                    children: [
                        { path: '', component: CertificatesHome},
                        { path: 'reprint', component: CertificatesReprint,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadCertifications');
                                store.dispatch('loadCertificates', true);
                                store.dispatch('loadCenters');
                                store.dispatch('loadUserProfiles');
                                next();
                            }
                        }
                    ]
                },
                {
                    path: 'reports',
                    component: Reports,
                    children: [
                        { path: '', component: ReportsHome },
                        { path: 'studentcerttracking', component: ReportsStudentCertificationTracking },
                        { path: 'injuryreport', component: ReportInjuryReport, meta: {
                            permission: Office
                        }
                    }
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('loadCertificates').finally(next);
                    }
                },
                {
                    path: 'students',
                    component: Students,
                    children: [
                        { path: '', component: StudentsHome},
                        { path: 'search', component: StudentsSearch},
                        { path: 'profile/:id', component: StudentProfileView, props: true},
                        { path: 'edit/:id', component: StudentEditView, props: true}
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('students/loadStudents', {root: true}).finally(next);
                    }
                },
                {
                    path: 'forms',
                    component: Forms,
                    children: [
                        { path: '', component: FormsHome},
                        { path: 'materialrequestform', component: MaterialRequestAdd,
                        beforeEnter: (to: any, from: any, next: any) => {
                            store.dispatch('material/loadMaterialItems', true);
                            next();
                            }
                        },
                        { path: 'materialrequestform/:id', component: MaterialRequestView, props: true},
                        { path: 'materialrequestform/:id/edit', component: MaterialRequestEdit, props: true},
                        { path: 'certificaterequestform', component: CertificateRequestFormAdd},
                        { path: 'certificaterequestform/:id', component: CertificateRequestFormView, props: true},
                        { path: 'injuryreportform', component: InjuryReportAdd,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadUserProfiles');
                                store.dispatch('injury/loadInjuryForms');
                                store.dispatch('injury/loadInjuryDocuments');
                                next();
                                }
                        },
                        { path: 'injuryreportform/:id', component: InjuryReportView, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadUserProfiles');
                                store.dispatch('injury/loadInjuryForms', true);
                                store.dispatch('injury/loadInjuryDocuments', true);
                                next();
                                }
                        },
                        { path: 'injuryreportform/:id/edit', component: InjuryReportEdit, props: true,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadUserProfiles');
                                store.dispatch('injury/loadInjuryForms', true);
                                store.dispatch('injury/loadInjuryDocuments', true);
                                next();
                                }
                        },
                        { path: 'requests', component: AllForms,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadCertificateForms', true);
                                store.dispatch('material/loadMaterialForms', true);
                                store.dispatch('loadUserProfiles');
                                store.dispatch('injury/loadInjuryForms', true);
                                next();
                            }
                        },
                        { path: 'actionableforms', component: ActionableForms,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('loadCertificateForms', true);
                                store.dispatch('material/loadMaterialForms', true);
                                store.dispatch('loadUserProfiles');
                                store.dispatch('injury/loadInjuryForms', true);
                                next();
                            }
                        }
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('loadCenters');
                        store.dispatch('loadUserProfiles');
                        store.dispatch('loadCertifications');
                        store.dispatch('loadCertificateForms', true);
                        store.dispatch('injury/loadInjuryForms', true);
                        store.dispatch('material/loadMaterialForms', true);
                        store.dispatch('material/loadMaterialItems', true);
                        store.dispatch('injury/loadInjuryDocuments', true);
                        next();
                    }
                },
                {
                    path: 'profile',
                    component: Profile,
                    children: [
                        { path: '', component: ProfileHome}
                    ],
                    beforeEnter: (to: any, from: any, next: any) => {
                        store.dispatch('initializeUserProfile', true);
                        next();
                    }
                },
                {
                    path: 'contact',
                    component: ContactHome
                },
                {
                    path: 'releasenotes',
                    component: ReleaseNotes,
                    children: [
                        { path: '', component: ReleaseNoteHome,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadReleaseNotes', true);
                                next();
                            }
                        }
                    ]
                },
                {
                    path: 'usernotifications',
                    component: UserNotifications,
                    children: [
                        { path: '', component: UserNotificationsHome,
                            beforeEnter: (to: any, from: any, next: any) => {
                                store.dispatch('notifications/loadUserNotifications', true);
                                next();
                            }
                        }
                    ]
                },
                {
                    path: '*',
                    component: Home
                }
            ]
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    trackPage(to.fullPath);
    next();
});

export default router;
